import NextImage from 'next/legacy/image';
import { TextLink } from '@/components/TextLink';
import { Image as DatoImage } from 'react-datocms';
import { ImageButtonLinkFragment } from '@/utils/dato/generated';

const ImageButtonLink = ({ openInNewTab, buttonImage, buttonLink }: ImageButtonLinkFragment) =>
  buttonLink ? (
    <TextLink
      target={openInNewTab ? '_blank' : undefined}
      data-automation="ZA.Block.ImageButtonLink"
      className="inline-block mb-6"
      href={buttonLink}
    >
      {buttonImage?.responsiveImage ? (
        <DatoImage data={buttonImage.responsiveImage} />
      ) : buttonImage?.url ? (
        <NextImage
          alt={buttonImage?.title || 'Link with an image'}
          height={buttonImage.height || undefined}
          width={buttonImage.width || undefined}
          className="rounded-xl object-cover"
          src={buttonImage.url}
        />
      ) : (
        <span className="text-sm text-gray-500 italic">No Image</span>
      )}
    </TextLink>
  ) : null;

export default ImageButtonLink;
